"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
export default function OurPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const partners = [{
    id: 1,
    name: "Sunbelt Rentals",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1507189/img/sunbelt_rentals_logo.png"
  }, {
    id: 2,
    name: "United Rentals",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1507189/img/united_rentals_logo.png"
  }];
  return <section id="our-partners" ref={ref} className="py-16 bg-background">
      <div className="container mx-auto px-4 max-w-6xl">
        <h2 className={`text-3xl md:text-4xl font-display font-bold text-center text-foreground mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Our Partners
        </h2>

        <div className="relative px-12">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4">
              {partners.map((partner, i) => <CarouselItem key={partner.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/2">
                  <div className={`p-8 bg-background rounded-lg border border-border shadow-soft flex items-center justify-center h-48 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-105 hover:shadow-medium ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                transitionDelay: `${i * 100}ms`
              }}>
                    <img src={partner.logo} alt={partner.name} className="max-w-full max-h-full object-contain filter grayscale hover:grayscale-0 transition-all duration-[var(--duration-medium)]" />
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="hover-lift focus-ring" />
            <CarouselNext className="hover-lift focus-ring" />
          </Carousel>
        </div>
      </div>
    </section>;
}